import { useInfiniteQuery } from "@tanstack/react-query";

import type { components, paths } from "@/api/types";
import type { Result } from "@/shared/api";
import { apiGetPage, nextCursor, PAGE_LIMIT, qk } from "@/shared/api";

export type AdminDeposit = Result<paths["/api/v1/admin/deposits"]["get"]>[number];
export type RequestStatus = components["schemas"]["RequestStatus"];

export function useDeposits(statuses: RequestStatus[]) {
  return useInfiniteQuery({
    queryKey: qk.deposits(statuses),
    initialPageParam: undefined as string | undefined,
    queryFn: ({ pageParam, signal }) =>
      apiGetPage("/api/v1/admin/deposits", {
        query: {
          limit: PAGE_LIMIT,
          ...(statuses.length ? { status: statuses } : {}),
          ...(pageParam ? { cursor: pageParam } : {}),
        },
        signal,
      }),
    getNextPageParam: (last) => nextCursor(last.meta),
  });
}
